import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import AdvancedSection from "./AdvancedSection";

export default function MontoTasaConfig({ config, onChange }) {
  const ma = config?.montoAsegurado || {};
  return (
    <div className="space-y-4">
      <div>
        <Label>Origen del monto asegurado</Label>
        <Select value={ma.origen || "plan"} onValueChange={(v) => onChange("montoAsegurado.origen", v)}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="request">Lo ingresa el cliente al cotizar</SelectItem>
            <SelectItem value="plan">Del plan (campo)</SelectItem>
            <SelectItem value="fijo">Valor fijo</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {ma.origen === "fijo" ? (
        <div>
          <Label className="text-xs text-gray-500">Valor fijo (UF)</Label>
          <Input type="number" value={ma.valor ?? ""} onChange={(e) => onChange("montoAsegurado.valor", parseFloat(e.target.value) || 0)} placeholder="Valor fijo del monto asegurado" />
        </div>
      ) : ma.origen === "request" ? (
        <p className="text-xs text-gray-500">El cliente ingresa el monto al cotizar (ej. el valor de su bicicleta). No requiere campo ni valor fijo.</p>
      ) : (
        <div>
          <Label className="text-xs text-gray-500">Campo del plan</Label>
          <Input value={ma.campo || ""} onChange={(e) => onChange("montoAsegurado.campo", e.target.value)} placeholder="capital_uf" />
        </div>
      )}

      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Tasa — Tabla</Label>
            <Input value={config?.tasa?.tabla || ""} onChange={(e) => onChange("tasa.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Tasa — Campo Resultado</Label>
            <Input value={config?.tasa?.campoResultado || ""} onChange={(e) => onChange("tasa.campoResultado", e.target.value)} placeholder="tasa" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
